import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { DownloadPdfProps } from 'shared/services';

export function usePdfExport<T>() {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation<void, Error, DownloadPdfProps<T>>(request => quoteService.downloadPdf(request), {
    onSuccess: () => {
      enqueueSnackbar('Quote was exported', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('Quote was not exported', { variant: 'error' });
    },
  });

  return mutation;
}
